
import Ugcs from "@/components/Ugcs.vue";
import axios from "axios";
import { Swiper } from "swiper/js/swiper.esm";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RelUgcBestVO } from "../ugc/vo/ugc.vo";

@Component({
  components: { Ugcs },
})
export default class BestFeeds extends Vue {
  @Prop({ default: true })
  active?: boolean;
  @Prop()
  propbestFeeds?: Array<RelUgcBestVO>;
  @Prop()
  ugcCd!: number;

  keyword = "";
  bestFeeds: Array<RelUgcBestVO> = [];

  // 인기유저 swiper
  swiperBest: Swiper;
  swiperBestOptions = {
    slidesPerView: 2.3,
    freeMode: true,
    spaceBetween: this.$isMobile ? 10 : 20,
    lazy: true,
    nested: true,    
  };

  // 베스트 보여줌?
  get showBests() {
    return this.$route.name === "Main" || !this.$isMobile;
  }

  @Watch("active", {immediate: true})
  onUgcActivated() {
    if(this.propbestFeeds) {
      this.bestFeeds = this.propbestFeeds;
    }
    !this.bestFeeds.length && this.getbestFeeds();
  }

  getbestFeeds(): void {
    const params = {
      ugcTypeCd: '047002'
    };
    axios.get(`/ugc/best`, { params: params }).then((r) => {
      this.bestFeeds = r.data as Array<RelUgcBestVO>;
      this.$emit("layout-update");
      this.swiperBest && this.swiperBest.slideTo(0);
    });
  }

}
